import styled from 'styled-components'
import { Typography, Row, Col, Button, Card } from 'antd'
import { Colors } from 'constants/Colors'
import FormatCell from 'components/FormatCell'
import { mdiAlertOutline, mdiPlusThick } from '@mdi/js'
import Icon from '@mdi/react'
import PregnantStatus from 'assets/svgs/pregnancy-status.svg'
import selectIcon from 'utils/selectIcon'

const { Link } = Typography
const Wrapper = styled.div`
  font-weight: 400;
  line-height: 18px;
  padding: 8px;
  & > p {
    color: black;
    margin: 0;
  }
  & > strong {
    display: block;
    text-transform: uppercase;
  }
  & > .subtitle {
    color: #afafaf;
    display: block;
    text-transform: uppercase;
  }
  & > .content {
    margin: 10px 0;
  }
  & > .content > p {
    margin: 0;
  }
  & > .links {
    margin-top: 10px;
  }
  & > .links > a {
    display: block;
  }
`

export default function InfoMap({ data }) {
  if (!data) return null
  const { content, title, subtitle, link, type, routerInfo, routersTags } = data

  switch (type) {
    case 'router': {
      const renderRouterInfo = () =>
        routerInfo.map(({ type, label, value, color }) => (
          <FormatCell
            key={type}
            type="animal-status"
            subType={type}
            label={label}
            value={value}
            color={color}
          />
        ))

      const renderTagRow = ({
        id,
        animal_link,
        cattle_earring,
        cattle_name,
        tag_link,
        name,
        time,
      }) => (
        <Row key={id} gutter={[4, 16]} style={styles.rowFlex}>
          <Col span={11} style={{ display: 'flex', justifyContent: 'center' }}>
            <Row style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <Link
                href={animal_link}
                style={{
                  ...styles.linkStyle,
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <Col span={6} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Icon path={selectIcon('animal')} size={1.3} style={styles.iconStyle} />
                </Col>
                <Col
                  span={18}
                  style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                >
                  <Typography.Text style={styles.cattleText}>{cattle_earring}</Typography.Text>
                  <Typography.Text style={styles.cattleTime}>{time}</Typography.Text>
                </Col>
              </Link>
            </Row>
          </Col>
          <Col span={5} style={{ display: 'flex', justifyContent: 'start' }}>
            <Typography.Text style={styles.cattleNameText}>{cattle_name}</Typography.Text>
          </Col>
          <Col span={7}>
            <Link href={tag_link}>
              <FormatCell type="tag" color="green" value={name} />
            </Link>
          </Col>
        </Row>
      )
      return (
        <Row style={{ minWidth: '550px' }}>
          <Col span={8} style={styles.colMiddle}>
            <div style={styles.colMiddleInner}>{renderRouterInfo()}</div>
            {link && (
              <div style={styles.colMiddleLink}>
                <Link href={link}>
                  <Button type="primary" size="small">
                    Acessar Antena
                  </Button>
                </Link>
              </div>
            )}
          </Col>
          <Col flex={1} style={styles.colInfo}>
            <Card className="not-margin">
              <div style={styles.cardContent}>{routersTags.map(renderTagRow)}</div>
            </Card>
          </Col>
        </Row>
      )
    }
    case 'device': {
      return (
        <Row>
          <Col span={13} style={styles.colLeft}>
            <FormatCell
              type="avatar"
              subtype="animal"
              title={data.earring}
              subtitle={data.name}
              isDeleted={false}
              has_device
            />
            {data.has_alert === true && (
              <Icon
                path={mdiAlertOutline}
                size={1.3}
                style={{
                  color: Colors.warning,
                }}
              />
            )}
          </Col>
          <Col flex={1} style={styles.colRight}>
            <Icon path={mdiPlusThick} size={0.95} style={styles.iconPlusThick(data.is_sick)} />
            {data.is_pregnant && (
              <img src={PregnantStatus} alt="status de gravidez" style={styles.pregnantStatusImg} />
            )}
          </Col>
          <Col span={14} style={styles.colMiddle}>
            <div>
              {data?.cattle_status?.map(item => {
                return (
                  <FormatCell
                    key={item.type}
                    type="animal-status"
                    subType={item.type}
                    label={item.label}
                    value={item.value}
                    color={item.color}
                  />
                )
              })}
            </div>
            {link ? (
              <div style={styles.colMiddleLink}>
                <Link key={`link-${link}`} href={link}>
                  <Button type={'primary'} size="small">
                    Acessar animal
                  </Button>
                </Link>
              </div>
            ) : null}
          </Col>
          <Col flex={1} style={styles.colInfo}>
            {data?.info_animal?.map((item, index) => {
              return (
                <FormatCell
                  key={`info-animal-${index}`}
                  type="animal-info"
                  value={item.value}
                  subType={item.type}
                />
              )
            })}
          </Col>
        </Row>
      )
    }

    default:
      return (
        <Wrapper>
          {title ? <strong>{title}</strong> : null}
          {subtitle ? <p className="subtitle">{subtitle}</p> : null}
          {content ? (
            <div className="content">
              {content?.map(({ key, value }, index) => (
                <p key={`content-${index}`}>
                  {key} : {value}
                </p>
              ))}
            </div>
          ) : null}
          {link ? (
            <div className="links">
              {link.map(({ key, value }, index) => {
                return (
                  <Link key={`link-${index}`} href={value}>
                    {key}
                  </Link>
                )
              })}
            </div>
          ) : null}
        </Wrapper>
      )
  }
}

const styles = {
  icon: {
    padding: 2,
    border: '1px solid',
    borderRadius: 200,
    verticalAlign: 'middle',
  },
  colLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 15,
  },
  colRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    justifyContent: 'end',
    marginBottom: 15,
  },
  colMiddle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: 10,
    justifyContent: 'space-around',
  },
  colMiddleInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  colMiddleLink: {
    marginTop: 10,
  },
  colInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconPlusThick: isSick => ({
    color: '#fff',
    backgroundColor: isSick ? '#D64A4A' : '#86BC6F',
    borderRadius: 60,
  }),
  pregnantStatusImg: {
    width: '28px',
    height: '28px',
  },
  rowFlex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },
  linkStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  cattleText: {
    whiteSpace: 'nowrap',
    color: `${Colors.primary}`,
    fontWeight: 'bold',
  },
  cattleTime: {
    whiteSpace: 'nowrap',
    fontSize: 11,
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  cattleNameText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 14,
    maxWidth: '100%',
  },
  cardContent: {
    height: '180px',
    overflowY: 'auto',
    padding: '10px',
  },
  iconStyle: {
    borderColor: Colors.primary,
    color: Colors.primary,
  },
}
